import apiService from "@/api/admin";

export default {
  namespaced: true,
  state: {
    authJournal: {},
    activityJournal: {
      count: 0,
      results: [],
    },
    activity_data_for_excel: [],
    auth_data_for_excel: [],
    expertise: [],
    backupListCount: 0,
    backupList: [],
  },
  getters: {
    GET_EXPERTISES: (state) => state.expertise,
    GET_AUTH_JOURNAL: (state) => state.authJournal,
    GET_ACTIVITY_JOURNAL: (state) => state.activityJournal,
    getActivityDataForExcel: (state) => state.activity_data_for_excel,
    getAuthDataForExcel: (state) => state.auth_data_for_excel,
    getBackupList(state) {
      return state.backupList;
    },
    getBackupListCount(state) {
      return state.backupListCount;
    },
  },
  mutations: {
    SET_AUTH_JOURNAL(state, payload) {
      state.authJournal = payload;
    },
    SET_ACTIVITY_JOURNAL(state, payload) {
      state.activityJournal = payload;
    },
    SET_ACTIVITY_DATA_FOR_EXCEL(state, payload) {
      state.activity_data_for_excel = payload;
    },
    SET_AUTH_DATA_FOR_EXCEL(state, payload) {
      state.auth_data_for_excel = payload;
    },
    SET_EXPERTISE_LIST(state, payload) {
      state.expertise = payload
    },
    SET_BACKUP_LIST(state, data) {
      state.backupList = data.results;
      state.backupListCount = data.count;
    },
  },
  actions: {
    FETCH_AUTH_JOURNAL({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .getAuthJournal(a)
          .then((res) => {
            commit("SET_AUTH_JOURNAL", res.data);
            resolve(res);
          })
          .catch(reject);
      });
    },
    FETCH_ACTIVITY_JOURNAL({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .getActivityJournal(a)
          .then((res) => {
            commit("SET_ACTIVITY_JOURNAL", res.data);
            resolve(res);
          })
          .catch(reject);
      });
    },
    FETCH_ACTIVITY_DATA_FOR_EXCEL({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .getActivityJournal(a)
          .then((res) => {
            commit("SET_ACTIVITY_DATA_FOR_EXCEL", res.data.results);
            resolve(res);
          })
          .catch(reject);
      });
    },
    FETCH_AUTH_DATA_FOR_EXCEL({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .getAuthJournal(a)
          .then((res) => {
            commit("SET_AUTH_DATA_FOR_EXCEL", res.data.results);
            resolve(res);
          })
          .catch(reject);
      });
    },
    PATCH_EXPERTISE({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .patchExpertise(a)
          .then((response) => {
            // console.log(response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    CREATE_EXPERTISE({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .createExpertise(a)
          .then((response) => {
            // console.log(response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    CREATE_BACKUP({commit}) {
      return new Promise((resolve, reject) => {
        apiService
          .createBackup()
          .then((response) => {
            // console.log(response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    FETCH_EXPERTISE({commit}, a) {
      return new Promise((resolve, reject) => {
        apiService
          .fetchExpertise(a)
          .then((response) => {
            commit("SET_EXPERTISE_LIST", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    FETCH_BACKUP_LIST({commit}, data) {
      return new Promise((resolve, reject) => {
        apiService
          .fetchBackupList(data)
          .then((response) => {
            commit("SET_BACKUP_LIST", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DELETE_EXPIRTISE({commit}, data) {
      return new Promise((resolve, reject) => {
        apiService
          .deleteExpertise(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DELETE_BACKUP({commit}, data) {
      return new Promise((resolve, reject) => {
        apiService
          .deleteBackup(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    DOWNLOAD_BACKUP({commit}, data) {
      return new Promise((resolve, reject) => {
        apiService
          .downloadBackup(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
